import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import free from '@/components/free'
import ordersuccess from '@/components/ordersuccess'
import shadow from '@/components/shadow'
import fenghuang from '@/components/fenghuang'
import kuaishou from '@/components/kuaishou'
import pdd from '@/components/pinduoduo'
import caseNot from '@/components/caseNot'
import single from '@/components/single'
import wangyi from '@/components/wangyi'
import sina from '@/components/sina'
import ua from '@/components/getUa'
import caseMid from '@/components/caseMid'
import shopIndex from '@/components/shopIndex'
import shopping from '@/components/shopping'
import payPage from '@/components/payPage'
import caseYes from '@/components/caseYes'
import orderResult from '@/components/orderResult'
import ceshi from '@/components/ceshi'
import itemize from '@/components/itemize'
import my from '@/components/my'  //我的
import coupon from '@/components/coupon'
import shop from '@/components/shopstore'
import credential from '@/components/credential'
import login from '@/components/login'  //登录
import register from '@/components/register'  //注册
import myorder from '@/components/myorder'
import afterSales from '@/components/afterSales'
import orderInfo from '@/components/orderInfo'
import agreement from '@/components/agreement'
import privacy from '@/components/privacy'
import logisticsPolicy from '@/components/logisticsPolicy'
import logistics from '@/components/logistics'
import bdShadow from '@/components/bdShadow'
import excellent from '@/components/excellent'
import caseNopdd from '@/components/caseNopdd'
import caseDy from '@/components/caseDy'
import sweet from '@/components/sweet'
Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/free',
      name: 'free',
      component: free
    },
    {
      path: '/ordersuccess',
      name: 'ordersuccess',
      component: ordersuccess
    },
    {
      path: '/shadow',
      name: 'shadow',
      component: shadow
    },
    {
      path: '/fenghuang',
      name: 'fenghuang',
      component: fenghuang
    },
    {
      path: '/kuaishou',
      name: 'kuaishou',
      component: kuaishou
    },
    {
      path: '/pdd',
      name: 'pdd',
      component: pdd
    },
    {
      path: '/single',
      name: 'single',
      component: single
    },
    {
      path: '/wangyi',
      name: 'wangyi',
      component: wangyi
    },
    {
      path: '/sina',
      name: 'sina',
      component: sina
    },
    {
      path: '/ua',
      name: 'ua',
      component: ua
    },
    {
      path: '/caseMid',
      name: 'caseMid',
      component: caseMid
    },
    // {
    //   path: '/shopIndex',
    //   name: 'shopIndex',
    //   component: shopIndex
    // },
    {
      path: '/shopping',
      name: 'shopping',
      component: shopping
    },
    {
      path: '/payPage',
      name: 'payPage',
      component: payPage
    },
    {
      path: '/caseNot',
      name: 'caseNot',
      component: caseNot
    },
    {
      path: '/caseYes',
      name: 'caseYes',
      component: caseYes
    },
    {
      path:'/orderResult',
      name:'orderResult',
      component:orderResult
    },
    {
      path:'/ceshi',
      name:'ceshi',
      component:ceshi
    },
    {
      path:'/itemize',
      name:'itemize',
      component:itemize
    },
    {
        path:'/my',
        name:'my',
        component:my
    },
    {
        path:'/coupon',
        name:'coupon',
        component:coupon
    },
    {
        path:'/shop',
        name:'shop',
        component:shop
    },
    {
        path:'/credential',
        name:'credential',
        component:credential
    },
    {
        path:'/login',
        name:'login',
        component:login
    },
    {
        path:'/register',
        name:'register',
        component:register
    },
    {
        path:'/myorder',
        name:'myorder',
        component:myorder
    },
    {
        path:'/afterSales',
        name:'afterSales',
        component:afterSales
    },
    {
        path:'/orderInfo',
        name:'orderInfo',
        component:orderInfo
    },
    {
        path:'/agreement',
        name:'agreement',
        component:agreement
    },
    {
        path:'/privacy',
        name:'privacy',
        component:privacy
    },
    {
        path:'/logisticsPolicy',
        name:'logisticsPolicy',
        component:logisticsPolicy
    },
    {
        path:'/bdShadow',
        name:'bdShadow',
        component:bdShadow
    },
    {
      path:'/logistics',
      name:'logistics',
      component:logistics
  },
  {
      path:'/excellent',
      name:'excellent',
      component:excellent
  },
  {
      path:'/caseNopdd',
      name:'caseNopdd',
      component:caseNopdd
  },
  {
      path:'/caseDy',
      name:'caseDy',
      component:caseDy
  },
  {
      path:'/sweet',
      name:'sweet',
      component:sweet
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js